import React from "react";
import BottomBar from "../../../components/BottomBar";
import Banner from "../../../components/Banner";

import { Bell } from "react-feather";
import "../../../assets/styles/payment.scss";

import {
  Col,
  Container,
  Button,
  Row,
  Card,
  CardBody,
  CardTitle,
  CardText,
  CardSubtitle,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
} from "reactstrap";

const PremiumCoursePayment = () => {
  const handleClick = () => {
    console.log("test");
  };
  return (
    <React.Fragment>
      <Container className="payment_container">
        <Row mb={3}>
          <Col md={12} sm={12}>
            <h3>결제하기</h3>
            <Card>
              <CardBody>
                <CardTitle tag="h5">수강신청 정보</CardTitle>
                <hr className="divider" />
                <CardSubtitle className="mb-2 text-muted" tag="h6">
                  강의명
                </CardSubtitle>
                <CardText>
                  프리미엄 A-level 강의 코스 (연 180회 수업 + PS + 학생 관리)
                </CardText>
                <CardSubtitle className="mb-2 text-muted" tag="h6">
                  기간
                </CardSubtitle>
                <CardText>1년 소장</CardText>
                <CardSubtitle className="mb-2 text-muted" tag="h6">
                  일정
                </CardSubtitle>
                <CardText>전체 오픈</CardText>
                <CardSubtitle className="mb-2 text-muted" tag="h6">
                  장소
                </CardSubtitle>
                <CardText>온라인 강의장</CardText>
                <hr className="divider2" />
                <CardSubtitle className="mb-2 text-muted" tag="h6">
                  이름
                </CardSubtitle>
                <CardText>강민재</CardText>
                <CardSubtitle className="mb-2 text-muted" tag="h6">
                  이메일
                </CardSubtitle>
                <CardText>jerrykang13@gmail.com</CardText>
                <Form>
                  <FormGroup>
                    <Label for="phone-number">전화번호 인증</Label>
                    <Input
                      type="text"
                      name="phone-number"
                      id="phone-number"
                      placeholder="-없이 숫자만 입력해주세요."
                    />
                    <Button className="send-verify-request">
                      인증번호 전송하기
                    </Button>
                  </FormGroup>
                  <FormGroup>
                    <Input
                      type="text"
                      name="verify"
                      id="verify"
                      placeholder="인증 번호 4자리를 입력해주세요"
                    />
                    <Button className="verify-phone-number">인증 하기</Button>
                  </FormGroup>
                </Form>
                <p>
                  정확한 수강 및 결제 안내, 상담 진행 등을 위해서 휴대전화
                  인증이 필요합니다. <br />
                  미인증 상태에서는 결제 안내, 상담 진행 등의 안내가 누락될 수
                  있습니다.
                </p>
                <Button className="make-payment">결제 하기</Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default PremiumCoursePayment;
